<style lang="less" scoped>
@import './styles/menu.less';
.more {
  width: 0.39rem;
  height: 0.39rem;
  background-color: #fbe3cb;
  border-radius: 50%;
}
.pendant{
  position: absolute;
  z-index: 1000;
  top: 0.4rem;
  img{
    width: 0.8rem;
  }
}
</style>

<template>
  <div class="ivu-shrinkable-menu">
    <slot name="top"></slot>
    <div class="xiong pendant">
     <img src="../../../assets/avatar_pendant.png">
    </div>
    <div class="xiong">
      <!-- <img src="../../../assets/xiongda.png" alt="" > -->
      <span class="avatarBorder">
        <Avatar :src="avatarPath" style="background: #619fe7"></Avatar>
      </span>
      <div>
        <!-- <p class="jifen">积分 {{ studentInfo.integration }}</p> -->
      </div>
    </div>
    <div class="info">
      <p>{{ userInfo.realName }}</p>
      <div class="org" :title="school">{{school}}</div>
      <div class="flower_box" v-if="medalArr.length !== 0">
        <div class="flower" v-for="(item, index) in medalArr" :key="index">
          <img :src="item.medalIcon" />
        </div>
      </div>
    </div>
    <sidebar-menu v-show="!shrink" :menu-theme="theme" :menu-list="menuList" :open-names="openNames" @on-change="handleChange"></sidebar-menu>
    <!-- <sidebar-menu-shrink
            v-show="shrink"
            :menu-theme="theme"
            :menu-list="menuList"
            :icon-color="shrinkIconColor"
            @on-change="handleChange"
        ></sidebar-menu-shrink> -->
    <!-- <div class="fkTitle">
      <Icon type="ios-paw" style="margin-right:.1rem"></Icon>最近访客
    </div> -->
    <!-- <div class="fkInfo" v-if="visitorRecordList.length!==0">
      <div class="fkAvatar" v-for="(item, index) in visitorRecordList" :key="index" :style="{ zIndex: 200 + index }">
        <span class="fkAvatarBorder" >
          <Avatar :src="item.avatar" style="background: #619fe7" v-if="item&&item.avatar"></Avatar>
        </span>
      </div>
    </div> -->
    <!-- <div class="qrCode">
      <img src="../../../assets/wxMp.jpg" alt="" />
    </div> -->
  </div>
</template>

<script>
import Util from '@/libs/util'
import sidebarMenu from './components/sidebarMenu.vue'
import imageA from '../../../assets/create_md.png'
import imageB from '../../../assets/grow_md.png'
// import sidebarMenuShrink from './components/sidebarMenuShrink.vue'
import { getStudentInfo } from '@/api/index'

export default {
  name: 'shrinkableMenu',
  data() {
    return {
      userInfo: {},
      studentInfo: {},
      organizationName: '',
      imageA: imageA,
      imageB: imageB,
      medalArr: [
        // {
        //   medalType: 0
        // },
        // {
        //   medalType: 1
        // }
        // {
        //   medalType: 1
        // },
        // {
        //   medalType: 1
        // }
      ],
      visitorRecordList: [],
      school: ''
    }
  },
  created() {
    this.userInfo = Util.localGet('userInfo')
    this.school = this.userInfo.campusName ? this.userInfo.organizationName + ' - ' + this.userInfo.campusName : this.userInfo.organizationName
    this.organizationName = Util.localGet('organizationName')
    this._getStudentInfo()
  },
  components: {
    sidebarMenu
    // sidebarMenuShrink
  },
  props: {
    shrink: {
      type: Boolean,
      default: false
    },
    menuList: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      default: 'light',
      validator(val) {
        return Util.oneOf(val, ['dark', 'light'])
      }
    },
    beforePush: {
      type: Function
    },
    openNames: {
      type: Array
    }
  },
  computed: {
    bgColor() {
      return this.theme === 'dark' ? '#515a6e' : '#fff'
      // return '#FCFCFA'
    },
    shrinkIconColor() {
      return this.theme === 'dark' ? '#fff' : '#515a6e'
    },
    avatarPath() {
      return this.$util.localGet('userInfo').avatar
    }
  },
  methods: {
    handleChange(name) {
      let willpush = true
      if (this.beforePush !== undefined) {
        if (!this.beforePush(name)) {
          willpush = false
        }
      }
      if (willpush) {
        this.$router.push({
          name: name
        })
      }
      this.$emit('on-change', name)
    },
    async _getStudentInfo() {
      const res = await getStudentInfo()
      if (res.success === true&&res.result) {
        this.studentInfo = res.result
        this.medalArr = res.result.medalInfoList
        this.visitorRecordList = res.result.visitorRecordList
        this.$util.localSet('studentInfo', res.result)
      }
    }
  },
  filters: {
    mobileFilter: function(value) {
      let arr = value.split('')
      arr.splice(3, 0, '-')
      arr.splice(8, 0, '-')
      let str = arr.join('')
      return str
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/main-components/shrinkable-menu/shrinkable-menu.vue